import api from '@/api';
import type { ThunkApiConfig } from '@/models/ThunkApiConfig';
import { thunkError } from '@/utils/thunkError';
import { createAsyncThunk } from '@reduxjs/toolkit';
import toastMessage from '@/components/Toast';
import { TransactionMidsData } from '../types';

export const fetchTransactionMids = createAsyncThunk.withTypes<ThunkApiConfig>()(
  'transactionCostAnalysis/fetchTransactionMids',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await api.fundLevelHedging.getTransactionMidsData(payload);
      // API returns { success: true, data: { results: [...] } }
      // So we need to access response.data.data to get { results: [...] }
      return response.data.data as TransactionMidsData;
    } catch (err: any) {
      return thunkError(err, rejectWithValue, { prefix: 'Failed to fetch transaction data' });
    }
  },
);
